/* Olilu: collection page behaviour (sections/collection-main.liquid).
   - Filter, sort, colour-family and paging links update the grid and filters through the Section Rendering API
     and history.pushState, falling back to normal navigation on any error.
   - "Show more" appends the next page; the real ?page= links stay in the markup for crawlers.
   - The description below the grid collapses after six lines with "Read more".
   Everything works without JavaScript: links are real links and the forms submit normally. */
(function () {
  'use strict';
  var O = window.Olilu;
  if (!O) return;

  var SWAP = ['ColTags', 'ColSide', 'ColMbar', 'ColMain', 'ColSheetBody', 'ColSheetFoot'];

  function cleanUrl(href) {
    var u = new URL(href, location.href);
    u.searchParams.delete('section_id');
    return u.toString();
  }

  function formUrl(form) {
    var u = new URL(form.getAttribute('action') || location.pathname, location.href);
    u.search = '';
    new FormData(form).forEach(function (v, k) {
      if (typeof v === 'string' && v.trim() !== '') u.searchParams.append(k, v.trim());
    });
    return u.toString();
  }

  function centreActiveTab(root) {
    var list = root.querySelector('[data-col-styles]');
    var cur = list && list.querySelector('[aria-current="page"]');
    if (!list || !cur || list.scrollWidth <= list.clientWidth) return;
    var li = cur.parentNode;
    list.scrollLeft = Math.max(0, li.offsetLeft - (list.clientWidth - li.offsetWidth) / 2);
  }

  O.ready('[data-col]', function (root) {
    var sid = root.getAttribute('data-col');
    var sheetId = 'ColSheet-' + sid;

    // A theme-editor reload leaves the previous sheet in <body> (drawers move there when opened)
    O.$$('[data-col-sheet="' + sid + '"]').forEach(function (d) { if (!root.contains(d)) d.remove(); });
    var sheet = document.getElementById(sheetId);

    function byKey(key, doc) { return (doc || document).getElementById(key + '-' + sid); }
    function alive() { return document.body.contains(root); }

    var pending = null;

    function swap(doc) {
      // remember open accordions and the focused control, so the swap feels seamless
      var open = {};
      SWAP.forEach(function (key) {
        var box = byKey(key);
        if (!box) return;
        O.$$('details[data-acc]', box).forEach(function (d) { open[key + ':' + d.getAttribute('data-acc')] = d.open; });
      });
      var a = document.activeElement;
      var focusKey = a && a !== document.body ? (a.getAttribute('data-fk') || a.id || '') : '';

      SWAP.forEach(function (key) {
        var cur = byKey(key), next = byKey(key, doc);
        if (!cur) return;
        if (next) cur.innerHTML = next.innerHTML;
        O.$$('a[href*="section_id="]', cur).forEach(function (l) { l.setAttribute('href', cleanUrl(l.href)); });
        O.$$('details[data-acc]', cur).forEach(function (d) {
          var k = key + ':' + d.getAttribute('data-acc');
          if (k in open) d.open = open[k];
        });
        O.init(cur);
      });

      if (focusKey) {
        var target = document.querySelector('[data-fk="' + focusKey + '"]') || document.getElementById(focusKey);
        if (target && target.offsetParent !== null) target.focus({ preventScroll: true });
      }

      var count = root.querySelector('.col-toolbar__count');
      var status = byKey('ColStatus');
      if (count && status) status.textContent = count.textContent;
      var opener = root.querySelector('[aria-controls="' + sheetId + '"]');
      if (opener && sheet) opener.setAttribute('aria-expanded', sheet.classList.contains('is-open') ? 'true' : 'false');
    }

    function load(url, push) {
      url = cleanUrl(url);
      var main = byKey('ColMain');
      var token = {};
      pending = token;
      if (main) { main.classList.add('is-loading'); main.setAttribute('aria-busy', 'true'); }
      return O.section(url, sid).then(function (html) {
        if (pending !== token || !alive()) return;
        swap(O.parse(html));
        if (push) history.pushState({ col: sid }, '', url);
        var sheetOpen = sheet && sheet.classList.contains('is-open');
        if (!sheetOpen && main && main.getBoundingClientRect().top < 0) {
          var y = window.scrollY + main.getBoundingClientRect().top - (parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0);
          window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
        }
      }).catch(function () {
        location.href = url;
      }).then(function () {
        if (pending === token && main) { main.classList.remove('is-loading'); main.removeAttribute('aria-busy'); }
      });
    }

    function showMore(link) {
      var href = cleanUrl(link.href);
      link.classList.add('is-loading');
      link.setAttribute('aria-busy', 'true');
      O.section(href, sid).then(function (html) {
        if (!alive()) return;
        var doc = O.parse(html);
        var grid = byKey('ColGrid'), nextGrid = byKey('ColGrid', doc);
        var pager = byKey('ColPager'), nextPager = byKey('ColPager', doc);
        if (!grid || !nextGrid) throw new Error('no grid');
        var first = null;
        O.$$('.col-grid__item', nextGrid).forEach(function (li) {
          grid.appendChild(li);
          if (!first) first = li;
        });
        if (pager) {
          if (nextPager) pager.innerHTML = nextPager.innerHTML;
          else pager.remove();
          O.$$('a[href*="section_id="]', pager).forEach(function (l) { l.setAttribute('href', cleanUrl(l.href)); });
        }
        O.init(grid);
        var focusTo = first && first.querySelector('.ccard__link');
        if (focusTo) focusTo.focus({ preventScroll: true });
        var status = byKey('ColStatus');
        var st = pager && pager.querySelector('.col-pager__status');
        if (status && st) status.textContent = st.textContent;
      }).catch(function () {
        location.href = href;
      });
    }

    // The sheet starts inside the section and moves to <body> when first opened, so events can reach
    // both listeners: handle each event once.
    function once(e) {
      if (e.__olCol) return false;
      e.__olCol = true;
      return true;
    }
    function fromForm(form) {
      var url = cleanUrl(formUrl(form));
      if (url !== location.href) load(url, true);
    }

    function onClick(e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || !once(e)) return;
      var more = e.target.closest('[data-col-more]');
      if (more) { e.preventDefault(); showMore(more); return; }
      var a = e.target.closest('a[data-col-link]');
      if (!a) return;
      e.preventDefault();
      load(a.href, true);
    }

    var debounced = O.debounce(fromForm, 700);
    function onChange(e) {
      var form = e.target.form;
      if (!form || !(form.hasAttribute('data-col-form') || form.hasAttribute('data-col-sort')) || !once(e)) return;
      if (e.target.type === 'number') { debounced(form); return; }
      if (e.type === 'change') fromForm(form);
    }
    function onSubmit(e) {
      var form = e.target;
      if (!(form.hasAttribute('data-col-form') || form.hasAttribute('data-col-sort')) || !once(e)) return;
      e.preventDefault();
      fromForm(form);
    }

    [root, sheet].forEach(function (scope) {
      if (!scope) return;
      scope.addEventListener('click', onClick);
      scope.addEventListener('change', onChange);
      scope.addEventListener('input', onChange);
      scope.addEventListener('submit', onSubmit);
    });

    if (!history.state || history.state.col !== sid) {
      try { history.replaceState({ col: sid }, '', location.href); } catch (err) { /* ignore */ }
    }
    window.addEventListener('popstate', function (e) {
      if (!alive() || !e.state || e.state.col !== sid) return;
      load(location.href, false);
    });

    centreActiveTab(root);
  });

  /* Description below the grid: collapsed after six lines */
  O.ready('[data-col-about]', function (box) {
    var body = box.querySelector('[data-col-about-body]');
    var btn = box.querySelector('[data-col-about-more]');
    if (!body || !btn) return;
    body.classList.add('is-collapsed');
    function check() {
      if (!body.classList.contains('is-collapsed')) return;
      var long = body.scrollHeight > body.clientHeight + 4;
      btn.hidden = !long;
      if (!long) body.classList.remove('is-collapsed');
    }
    requestAnimationFrame(check);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(check);
    btn.addEventListener('click', function () {
      var expanded = body.classList.toggle('is-collapsed') === false;
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      btn.textContent = expanded ? 'Read less' : 'Read more';
    });
  });
})();
